import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import type { AssessmentResult } from '../entities/AssessmentResult'

@InputType()
export class UpdateStudentNameArgs extends ActionArgs {
  @Field(() => ID)
  resultId: string

  @Field(() => String)
  studentName: string
}

export interface IUpdateStudentName extends IAction<AssessmentResult, UpdateStudentNameArgs> {}
